import {
    SiPython,
    SiSnowflake,
    SiApacheairflow,
    SiApachekafka,
    SiR,
    SiMysql,
    SiDatabricks,
    SiFigma,
    SiScikitlearn,
    SiTensorflow,
    SiOpenai,
    SiDocker,
    SiSupabase,
    SiPostgresql,
    SiAmazonaws,
    SiGooglecloud,
    SiPytorch,
    SiFastapi,
    SiDbt,
    SiApachespark,
    SiLatex,
    SiMongodb,
    SiLangchain,
    SiKubernetes,
    SiTerraform,
    SiMlflow,
    SiGithubactions,
    SiQlik
} from "react-icons/si";
import {FaGitAlt} from "react-icons/fa";
import {VscAzure} from "react-icons/vsc";
import {PiCertificateFill} from "react-icons/pi";
import {MdDashboard} from "react-icons/md";
import {IoLogoTableau} from "react-icons/io5";

import React from "react";

const skillsConfig = {
    mainSkills: [
        {
            id: "skills-0",
            className: "skill-icon",
            icon: <SiPython size={35}/>,
            text: "Python"
        },
        {
            id: "skills-1",
            className: "skill-icon",
            icon: <VscAzure size={35}/>,
            text: "Azure"
        },
        {
            id: "skills-2",
            className: "skill-icon",
            icon: <SiDatabricks size={35}/>,
            text: "Databricks"
        },
        {
            id: "skills-6",
            className: "skill-icon",
            icon: <MdDashboard size={35}/>,
            text: "Power BI"
        },
        {
            id: "skills-24",
            className: "skill-icon",
            icon: <IoLogoTableau size={35}/>,
            text: "Tableau"
        },
        {
            id: "skills-25",
            className: "skill-icon",
            icon: <SiQlik size={35}/>,
            text: "Qlik Sense"
        },
        {
            id: "skills-4",
            className: "skill-icon",
            icon: <SiDbt size={35}/>,
            text: "dbt"
        },
        {
            id: "skills-5",
            className: "skill-icon",
            icon: <SiSnowflake size={35}/>,
            text: "Snowflake"
        },
        {
            id: "skills-18",
            className: "skill-icon",
            icon: <SiMongodb size={35}/>,
            text: "MongoDB"
        }
    ],
    complementarySkills: [
        {
            id: "skills-3",
            className: "skill-icon",
            icon: <SiApachespark size={35}/>,
            text: "Spark"
        },
        {
            id: "skills-7",
            className: "skill-icon",
            icon: <SiOpenai size={35}/>,
            text: "GenAI/LLMs"
        },
        {
            id: "skills-19",
            className: "skill-icon",
            icon: <SiLangchain size={35}/>,
            text: "LangChain"
        },
        {
            id: "skills-8",
            className: "skill-icon",
            icon: <SiScikitlearn size={35}/>,
            text: "Scikit-Learn"
        },
        {
            id: "skills-9",
            className: "skill-icon",
            icon: <SiTensorflow size={35}/>,
            text: "TensorFlow"
        },
        {
            id: "skills-10",
            className: "skill-icon",
            icon: <SiPytorch size={35}/>,
            text: "PyTorch"
        },
        {
            id: "skills-11",
            className: "skill-icon",
            icon: <SiFastapi size={35}/>,
            text: "FastAPI"
        },
        {
            id: "skills-12",
            className: "skill-icon",
            icon: <SiDocker size={35}/>,
            text: "Docker"
        },
        {
            id: "skills-20",
            className: "skill-icon",
            icon: <SiKubernetes size={35}/>,
            text: "Kubernetes"
        },
        {
            id: "skills-21",
            className: "skill-icon",
            icon: <SiTerraform size={35}/>,
            text: "Terraform"
        },
        {
            id: "skills-13",
            className: "skill-icon",
            icon: <FaGitAlt size={35}/>,
            text: "Git"
        },
        {
            id: "skills-22",
            className: "skill-icon",
            icon: <SiGithubactions size={35}/>,
            text: "CI/CD"
        },
        {
            id: "skills-14",
            className: "skill-icon",
            icon: <SiApachekafka size={35}/>,
            text: "Kafka"
        },
        {
            id: "skills-15",
            className: "skill-icon",
            icon: <SiApacheairflow size={35}/>,
            text: "Airflow"
        },
        {
            id: "skills-16",
            className: "skill-icon",
            icon: <SiPostgresql size={35}/>,
            text: "PostgreSQL"
        },
        {
            id: "skills-23",
            className: "skill-icon",
            icon: <SiMlflow size={35}/>,
            text: "MLflow"
        }
    ],
    certifications: [
        {
            id: "cert-0",
            className: "skill-icon",
            icon: <PiCertificateFill size={35}/>,
            text: "Fabric Data Engineer (DP-700)"
        },
        {
            id: "cert-1",
            className: "skill-icon",
            icon: <PiCertificateFill size={35}/>,
            text: "Fabric Analytics Engineer (DP-600)"
        },
        {
            id: "cert-2",
            className: "skill-icon",
            icon: <PiCertificateFill size={35}/>,
            text: "Databricks Data Engineer"
        },
        {
            id: "cert-3",
            className: "skill-icon",
            icon: <PiCertificateFill size={35}/>,
            text: "Azure Data Fundamentals"
        },
        {
            id: "cert-6",
            className: "skill-icon",
            icon: <PiCertificateFill size={35}/>,
            text: "Airflow Fundamentals"
        },
        {
            id: "cert-4",
            className: "skill-icon",
            icon: <PiCertificateFill size={35}/>,
            text: "dbt Fundamentals"
        },
        {
            id: "cert-5",
            className: "skill-icon",
            icon: <PiCertificateFill size={35}/>,
            text: "Power BI Masters"
        }
    ]
}

export default skillsConfig
